import { UpdateAvailabilityPage } from "./UpdateAvailabilityPage";
export default UpdateAvailabilityPage;
